import styled from "@emotion/styled";
import { ModalActions, ModalContent } from "@kaltura/ds-react-components";

export const StyledModalContent = styled(ModalContent)(({ theme }) => ({
    width: 584,
}));

export const StyledModalActions = styled(ModalActions)(({ theme }) => ({
    padding: theme.spacing(2, 5, 2, 5),
    borderTop: `1px solid ${theme.kaltura.palette.tone4}`,
}));
